<div class="flex flex-row gap-2">
  <button mat-raised-button color="primary" [disabled]="loading" (click)="downloadReconciliationFile()">
    Download reconciliation file
  </button>
  <button mat-raised-button color="primary" [disabled]="loading" (click)="downloadPaymentsBatch()">
    Download payments batch
  </button>
  <button mat-raised-button color="primary" [disabled]="loading || disableMarkAsSent" (click)="markAsSent()">
    Mark as sent
  </button>
</div>
